/**
 * Block-for-block skeleton for /billing/kitchen (Plan 20).
 *
 * Mirrors the live page layout: next-payout card + history table.
 *
 * Per the apps/ordo Loading-state convention (`@ordo/ui/skeleton`,
 * never a `Loading…` text fallback), this renders the same DOM
 * structure as `KitchenPayoutsPage` so the swap is imperceptible.
 */

import { Card, CardContent, CardHeader } from '@ordo/ui/card'
import { Skeleton } from '@ordo/ui/skeleton'

export function BillingKitchenSkeleton() {
  return (
    <div className="flex flex-col gap-6" aria-busy="true" aria-label="Loading kitchen payouts">
      {/* Next payout card — total + cycle date + 4 kind subtotals. */}
      <Card className="p-6">
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div className="flex flex-col gap-2">
            <Skeleton className="h-3 w-24" />
            <Skeleton className="h-9 w-40" />
            <Skeleton className="h-4 w-48" />
          </div>
          <Skeleton className="h-6 w-20 rounded-full" />
        </div>
        <Skeleton className="my-4 h-px w-full" />
        <div className="grid grid-cols-1 gap-y-1.5 sm:grid-cols-2 sm:gap-x-6">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="flex items-baseline justify-between">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-4 w-16" />
            </div>
          ))}
        </div>
      </Card>

      {/* History table */}
      <Card>
        <CardHeader>
          <Skeleton className="h-5 w-32" />
        </CardHeader>
        <CardContent>
          <div className="flex flex-col gap-3">
            {Array.from({ length: 5 }).map((_, i) => (
              <HistoryRowSkeleton key={i} />
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

function HistoryRowSkeleton() {
  return (
    <div className="flex items-center gap-3 border-b pb-3 last:border-b-0">
      <Skeleton className="h-4 w-24" />
      <Skeleton className="h-4 w-20" />
      <Skeleton className="h-5 w-16 rounded-full" />
      <div className="flex-1" />
      <Skeleton className="h-4 w-24" />
      <Skeleton className="h-4 w-4" />
    </div>
  )
}
